import BalletDancer from '../images/ListenChooseRelevant/Lesson1.2/images/balletdancer.jpg';
import Сhauffeur from '../images/ListenChooseRelevant/Lesson1.2/images/chauffeur.jpg';
import Journalist from '../images/ListenChooseRelevant/Lesson1.2/images/journalist.jpg';
import President from '../images/ListenChooseRelevant/Lesson1.2/images/obama.jpg';
import Boxer from '../images/ListenChooseRelevant/Lesson1.3/Images/boxing.jpg';
import Musician from '../images/ListenChooseRelevant/Lesson1.3/Images/mozart.jpg';

import Footballer from '../images/ListenChooseRelevant/Lesson1.3/Images/footballer.jpg';
import Politiian from '../images/ListenChooseRelevant/Lesson1.3/Images/angela_merkel.jpg';
import Conductor from '../images/ListenChooseRelevant/Lesson1.3/Images/conductor.jpg';
import Physicist from '../images/ListenChooseRelevant/Lesson1.3/Images/einstein.jpg';
import Arhitect from '../images/COSOC/Lesson 1.3/architect_man.jpg';
import Photograph from '../images/COSOC/Lesson 1.3/photographer_woman.jpg';
import Engineer from '../images/COSOC/Lesson 1.3/man_engineer.jpg';
const _ = require('lodash');


// Lesson 1.1
export const MGdata0 = _.shuffle([
  {
    value: "телевизор",
    pic: 'https://res.cloudinary.com/nzmai/image/upload/v1596370581/russian%20course/technology%20icons%20and%20pics/television.png'
  },
  {
    value: "телевизор",
    pic: ''
  },
  {
    value: "телефон",
    pic: 'https://res.cloudinary.com/nzmai/image/upload/v1596370581/russian%20course/technology%20icons%20and%20pics/telephone.png'
  },
  {
    value: "телефон",
    pic: ''
  },
  {
    value: "радио",
    pic: 'https://res.cloudinary.com/nzmai/image/upload/v1596370581/russian%20course/technology%20icons%20and%20pics/radio.png'
  },
  {
    value: "радио",
    pic: ''
  },
  {
    value: "фотокамера",
    pic: "https://res.cloudinary.com/nzmai/image/upload/v1596370581/russian%20course/technology%20icons%20and%20pics/camera.png"
  },
  {
    value: "фотокамера",
    pic: ''
  },
  {
    value: "принтер",
    pic: "https://res.cloudinary.com/nzmai/image/upload/v1596370580/russian%20course/technology%20icons%20and%20pics/printer.png"
  },
  {
    value: "принтер",
    pic: ''
  },
  {
    value: "смартфон",
    pic: "https://res.cloudinary.com/nzmai/image/upload/v1596370580/russian%20course/technology%20icons%20and%20pics/smartphone.png"
  },
  {
    value: "смартфон",
    pic: ''
  },
  {
    value: "планшет",
    pic: "https://res.cloudinary.com/nzmai/image/upload/v1596370580/russian%20course/technology%20icons%20and%20pics/tablet.png"
  },
  {
    value: "планшет",
    pic: ''
  },
  {
    value: "компьютер",
    pic: "https://res.cloudinary.com/nzmai/image/upload/v1596370580/russian%20course/technology%20icons%20and%20pics/computer.png"
  },
  {
    value: "компьютер",
    pic: ''
  }
]);

export const MGdata01 = _.shuffle([
  {
    value: "франция",
    pic: 'https://res.cloudinary.com/nzmai/image/upload/v1596380247/russian%20course/countries%20flags/france.png'
  },
  {
    value: "франция",
    pic: ''
  },
  {
    value: "китай",
    pic: 'https://res.cloudinary.com/nzmai/image/upload/v1596379923/russian%20course/countries%20flags/china.png'
  },
  {
    value: "китай",
    pic: ''
  },
  {
    value: "россия",
    pic: 'https://res.cloudinary.com/nzmai/image/upload/v1596379923/russian%20course/countries%20flags/russia.png'
  },
  {
    value: "россия",
    pic: ''
  },
  {
    value: "сша",
    pic: "https://res.cloudinary.com/nzmai/image/upload/v1596379923/russian%20course/countries%20flags/usa.png"
  },
  {
    value: "сша",
    pic: ''
  },
  {
    value: "япония",
    pic: "https://res.cloudinary.com/nzmai/image/upload/v1596379923/russian%20course/countries%20flags/japan.png"
  },
  {
    value: "япония",
    pic: ''
  },
  {
    value: "германия",
    pic: "https://res.cloudinary.com/nzmai/image/upload/v1596379923/russian%20course/countries%20flags/germany.png"
  },
  {
    value: "германия",
    pic: ''
  }
]);

export const MGdata02 = _.shuffle([
  {
    value: "фэйсбук",
    pic: 'https://res.cloudinary.com/nzmai/image/upload/v1596449655/russian%20course/brand%20logos/facebook.png'
  },
  {
    value: "фэйсбук",
    pic: ''
  },
  {
    value: "самсунг",
    pic: 'https://res.cloudinary.com/nzmai/image/upload/v1596449660/russian%20course/brand%20logos/samsung.png'
  },
  {
    value: "самсунг",
    pic: ''
  },
  {
    value: "гугл",
    pic: 'https://res.cloudinary.com/nzmai/image/upload/v1596449659/russian%20course/brand%20logos/google.png'
  },
  {
    value: "гугл",
    pic: ''
  },
  {
    value: "аппл",
    pic: "https://res.cloudinary.com/nzmai/image/upload/v1596449659/russian%20course/brand%20logos/apple.png"
  },
  {
    value: "аппл",
    pic: ''
  },
  {
    value: "тесла",
    pic: "https://res.cloudinary.com/nzmai/image/upload/v1596449658/russian%20course/brand%20logos/tesla.png"
  },
  {
    value: "тесла",
    pic: ''
  },
  {
    value: "майкрософт",
    pic: "https://res.cloudinary.com/nzmai/image/upload/v1596449658/russian%20course/brand%20logos/microsoft.png"
  },
  {
    value: "майкрософт",
    pic: ''
  },
  {
    value: "твиттер",
    pic: "https://res.cloudinary.com/nzmai/image/upload/v1596449655/russian%20course/brand%20logos/twitter.png"
  },
  {
    value: "твиттер",
    pic: ''
  },
  {
    value: "найк",
    pic: "https://res.cloudinary.com/nzmai/image/upload/v1596449655/russian%20course/brand%20logos/nike.png"
  },
  {
    value: "найк",
    pic: ''
  }
]);

// Lesson 1.2
export const MGdata1 = _.shuffle([
  {
    value: "балерина",
    pic: BalletDancer
  },
  {
    value: "балерина",
    pic: ''
  },
  {
    value: "шофёр",
    pic: Сhauffeur
  },
  {
    value: "шофёр",
    pic: ''
  },
  {
    value: "журналист",
    pic: Journalist
  },
  {
    value: "журналист",
    pic: ''
  },
  {
    value: "президент",
    pic: President
  },
  {
    value: "президент",
    pic: ''
  },
  {
    value: "боксёр",
    pic: Boxer
  },
  {
    value: "боксёр",
    pic: ''
  },
  {
    value: "музыкант",
    pic: Musician
  },
  {
    value: "музыкант",
    pic: ''
  }
]);

export const MGdata2 = _.shuffle([
  {
    value: "я",
    pic: ''
  },
  {
    value: "я",
    pic: ''
  },
  {
    value: "ты",
    pic: ''
  },
  {
    value: "ты",
    pic: ''
  },
  {
    value: "он",
    pic: ''
  },
  {
    value: "он",
    pic: ''
  },
  {
    value: "она",
    pic: ''
  },
  {
    value: "она",
    pic: ''
  },
  {
    value: "мы",
    pic: ''
  },
  {
    value: "мы",
    pic: ''
  },
  {
    value: "они",
    pic: ''
  },
  {
    value: "они",
    pic: ''
  },
  {
    value: "вы",
    pic: ''
  },
  {
    value: "вы",
    pic: ''
  },
  {
    value: "оно",
    pic: ''
  },
  {
    value: "оно",
    pic: ''
  }
]);

export const MGdata3 = _.shuffle([
  {
    value: "Один (1)",
    pic: ''
  },
  {
    value: "Один (1)",
    pic: ''
  },
  {
    value: "Два (2)",
    pic: ''
  },
  {
    value: "Два (2)",
    pic: ''
  },
  {
    value: "Три (3)",
    pic: ''
  },
  {
    value: "Три (3)",
    pic: ''
  },
  {
    value: "Четыре (4)",
    pic: ''
  },
  {
    value: "Четыре (4)",
    pic: ''
  },
  {
    value: "Пять (5)",
    pic: ''
  },
  {
    value: "Пять (5)",
    pic: ''
  },
  {
    value: "Шесть (6)",
    pic: ''
  },
  {
    value: "Шесть (6)",
    pic: ''
  },
  {
    value: "Семь (7)",
    pic: ''
  },
  {
    value: "Семь (7)",
    pic: ''
  },
  {
    value: "Восемь (8)",
    pic: ''
  },
  {
    value: "Восемь (8)",
    pic: ''
  },
  {
    value: "Девять (9)",
    pic: ''
  },
  {
    value: "Девять (9)",
    pic: ''
  }
]);

// Lesson 1.3
export const MGdata4 = _.shuffle([
  {
    value: "я (меня)",
    pic: ''
  },
  {
    value: "я (меня)",
    pic: ''
  },
  {
    value: "ты (тебя)",
    pic: ''
  },
  {
    value: "ты (тебя)",
    pic: ''
  },
  {
    value: "он (его)",
    pic: ''
  },
  {
    value: "он (его)",
    pic: ''
  },
  {
    value: "она (её)",
    pic: ''
  },
  {
    value: "она (её)",
    pic: ''
  },
  {
    value: "вы (вас)",
    pic: ''
  },
  {
    value: "вы (вас)",
    pic: ''
  },
  {
    value: "мы (нас)",
    pic: ''
  },
  {
    value: "мы (нас)",
    pic: ''
  },
  {
    value: "они (их)",
    pic: ''
  },
  {
    value: "они (их)",
    pic: ''
  },
  {
    value: "оно (его)",
    pic: ''
  },
  {
    value: "оно (его)",
    pic: ''
  }
]);

export const MGdata5 = _.shuffle([
  {
    value: "футболист",
    pic: Footballer
  },
  {
    value: "футболист",
    pic: ''
  },
  {
    value: "Политик",
    pic: Politiian
  },
  {
    value: "Политик",
    pic: ''
  },
  {
    value: "Дирижёр",
    pic: Conductor
  },
  {
    value: "Дирижёр",
    pic: ''
  },
  {
    value: "Физик",
    pic: Physicist
  },
  {
    value: "Физик",
    pic: ''
  },
  {
    value: "Архитектор",
    pic: Arhitect
  },
  {
    value: "Архитектор",
    pic: ''
  },
  {
    value: "Фотограф",
    pic: Photograph
  },
  {
    value: "Фотограф",
    pic: ''
  },
  {
    value: "Инженер",
    pic: Engineer
  },
  {
    value: "Инженер",
    pic: ''
  }
]);

// Lesson 2.1
export const MGdata6 = _.shuffle([
  {
    value: "учитель/школа",
    pic: ''
  },
  {
    value: "учитель/школа",
    pic: ''
  },
  {
    value: "профессор/университет",
    pic: ''
  },
  {
    value: "профессор/университет",
    pic: ''
  },
  {
    value: "доктор/больница",
    pic: ''
  },
  {
    value: "доктор/больница",
    pic: ''
  },
  {
    value: "депутат/парламент",
    pic: ''
  },
  {
    value: "депутат/парламент",
    pic: ''
  },
  {
    value: "банкир/банк",
    pic: ''
  },
  {
    value: "банкир/банк",
    pic: ''
  },
  {
    value: "актёр/театр",
    pic: ''
  },
  {
    value: "актёр/театр",
    pic: ''
  },
  {
    value: "секретарь/офис",
    pic: ''
  },
  {
    value: "секретарь/офис",
    pic: ''
  }
]);

export const MGdata7 = _.shuffle([
  {
    value: "Я работаю",
    pic: ''
  },
  {
    value: "Я работаю",
    pic: ''
  },
  {
    value: "Ты работаешь",
    pic: ''
  },
  {
    value: "Ты работаешь",
    pic: ''
  },
  {
    value: "Он работает",
    pic: ''
  },
  {
    value: "Он работает",
    pic: ''
  },
  {
    value: "Она работает",
    pic: ''
  },
  {
    value: "Она работает",
    pic: ''
  },
  {
    value: "Вы работаете",
    pic: ''
  },
  {
    value: "Вы работаете",
    pic: ''
  },
  {
    value: "Мы работаем",
    pic: ''
  },
  {
    value: "Мы работаем",
    pic: ''
  },
  {
    value: "Они работают",
    pic: ''
  },
  {
    value: "Они работают",
    pic: ''
  }
]);

export const MGdata8 = _.shuffle([
  {
    value: "Я встаю",
    pic: ''
  },
  {
    value: "Я встаю",
    pic: ''
  },
  {
    value: "Ты встаёшь",
    pic: ''
  },
  {
    value: "Ты встаёшь",
    pic: ''
  },
  {
    value: "Он встаёт",
    pic: ''
  },
  {
    value: "Он встаёт",
    pic: ''
  },
  {
    value: "Она встаёт",
    pic: ''
  },
  {
    value: "Она встаёт",
    pic: ''
  },
  {
    value: "Вы встаёте",
    pic: ''
  },
  {
    value: "Вы встаёте",
    pic: ''
  },
  {
    value: "Мы встаёте",
    pic: ''
  },
  {
    value: "Мы встаёте",
    pic: ''
  },
  {
    value: "Они встают",
    pic: ''
  },
  {
    value: "Они встают",
    pic: ''
  }
]);

export const MGdata9 = _.shuffle([
  {
    value: "Я иду",
    pic: ''
  },
  {
    value: "Я иду",
    pic: ''
  },
  {
    value: "Ты идёшь",
    pic: ''
  },
  {
    value: "Ты идёшь",
    pic: ''
  },
  {
    value: "Он идёт",
    pic: ''
  },
  {
    value: "Он идёт",
    pic: ''
  },
  {
    value: "Она идёт",
    pic: ''
  },
  {
    value: "Она идёт",
    pic: ''
  },
  {
    value: "Вы идёте",
    pic: ''
  },
  {
    value: "Вы идёте",
    pic: ''
  },
  {
    value: "Мы идём",
    pic: ''
  },
  {
    value: "Мы идём",
    pic: ''
  },
  {
    value: "Они идут",
    pic: ''
  },
  {
    value: "Они идут",
    pic: ''
  }
]);

